var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3674 8.66406L9.02736 10.0086C8.48396 10.5539 7.52783 10.5657 6.97267 10.0086L5.63258 8.66406L0.81958 13.4927C0.998736 13.5755 1.19627 13.625 1.40627 13.625H14.5938C14.8038 13.625 15.0012 13.5756 15.1803 13.4927L10.3674 8.66406Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5937 2.375H1.40621C1.19621 2.375 0.998674 2.42444 0.81958 2.50728L5.96261 7.66738C5.96295 7.66772 5.96336 7.66778 5.96371 7.66813C5.96405 7.66847 5.96411 7.66894 5.96411 7.66894L7.63639 9.34675C7.81402 9.52438 8.18595 9.52438 8.36358 9.34675L10.0355 7.66922C10.0355 7.66922 10.0359 7.66847 10.0363 7.66813C10.0363 7.66813 10.037 7.66772 10.0374 7.66738L15.1803 2.50725C15.0012 2.42438 14.8037 2.375 14.5937 2.375Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.149562 3.16284C0.056875 3.35028 0 3.55834 0 3.78122V12.2187C0 12.4416 0.0568125 12.6497 0.149531 12.8371L4.97087 8.00012L0.149562 3.16284Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8503 3.16284L11.0291 8.00019L15.8503 12.8372C15.943 12.6498 15.9999 12.4417 15.9999 12.2188V3.78128C15.9999 3.55834 15.943 3.35028 15.8503 3.16284Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTextIcon);
export default __webpack_public_path__ + "static/media/EmailTextIcon.e6251870de4149878c036ee761a1d976.svg";
export { ForwardRef as ReactComponent };